import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/165188d6/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineNotification = makeShortcode("InlineNotification");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3 {...{
      "id": "depending-on-the-complexity-of-the-use-case-and-user-needs-chatbots-may-require-other-interactions-that-supplement-the-conversational-experience"
    }}>{`Depending on the complexity of the use case and user needs, chatbots may require other interactions that supplement the conversational experience.`}</h3>
    <InlineNotification mdxType="InlineNotification">
      <p><strong parentName="p">{`Note:`}</strong>{` This page documents some common chatbot scenarios in IBM products and their recommended best practices. Flows still under consideration are marked with “Experimental”.`}</p>
    </InlineNotification>
    <AnchorLinks mdxType="AnchorLinks">
      <AnchorLink mdxType="AnchorLink">Launching a bot</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Multiple threads</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Expanding cards</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Error states</AnchorLink>
    </AnchorLinks>
    <h2 {...{
      "id": "launching-a-bot"
    }}>{`Launching a bot`}</h2>
    <p>{`Bots should be launched from a button positioned at the bottom right of the screen, or from a button embedded within the UI. See Carbon Chatbot Add-on Design Kit for the appropriate variants.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAAA00lEQVQoz6WSXQ6CMBCEvf89fPAgJp7B8AABjQ+ayF9bCtuRgaCUGIpxk0mh3f0623aHPpxzqwrlzNd3a8ki4hXwf6m/gF3XwVrriXObgUyegIymaVBVFeq6HsRvQn8C0uUUxhjkeY6iKN7iJkHg1OoSqHsgXSmlBoebgPPDduIDldJI0xRJEiPLLiiLZ99y0OFYLOKgGoI/F0NnURQhjglMcbvnUDrkcCh2eJSC/dEQPWxCsT22qvQ4fzhZnK/jpUio5bbtUOv26zvk2VLGchTP4QuXRhQKto+xewAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Launching a bot",
        "title": "Launching a bot",
        "src": "/static/e5b4f571dfb3845d9b14adc51ee6ca3c/fb070/chatbot-5.png",
        "srcSet": ["/static/e5b4f571dfb3845d9b14adc51ee6ca3c/d6747/chatbot-5.png 288w", "/static/e5b4f571dfb3845d9b14adc51ee6ca3c/09548/chatbot-5.png 576w", "/static/e5b4f571dfb3845d9b14adc51ee6ca3c/fb070/chatbot-5.png 1152w", "/static/e5b4f571dfb3845d9b14adc51ee6ca3c/fb104/chatbot-5.png 1728w", "/static/e5b4f571dfb3845d9b14adc51ee6ca3c/902fb/chatbot-5.png 2304w", "/static/e5b4f571dfb3845d9b14adc51ee6ca3c/3ff35/chatbot-5.png 2400w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <h2 {...{
      "id": "multiple-threads-experimental"
    }}>{`Multiple threads (Experimental)`}</h2>
    <p>{`When a bot cannot complete a request, the bot detects frustration, or the user would simply prefer interacting with a person, it becomes necessary to connect the user to a human agent.`}</p>
    <h3 {...{
      "id": "user-initiates-change"
    }}>{`User initiates change`}</h3>
    <p>{`Sometimes, a user indicates that they would like to chat with a human. Other times, this process can be suggested if a bot is repeatedly unsuccessful in answering a user’s question.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "48.839285714285715%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAAA10lEQVQoz6WSvQ6CMBSFeXQm3oEHYWMjTKxODqhgiGCw2B8o0HKENhoHdagnbdqe3H45yb0ePmhZFrM3EaYwyHF9ayilXv57zbu870B7L2qOS3OF6DkYY5imyQ34POUgIIQA5xY4z7NrQltMKUUYhvB9H0EQoK5r42ut3YBt2yLLMiRJgjRNTUq3hLAf6J0iP+SIoghxHJvEzsBtEUJwLkucTkdUVYXx36YwLtZUHLeuw51cV1fZCXAFil6Cst6AdsWIfWUTatcub2MipVzNGXmjUbbLT+ADA8sOgRqBUDAAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "User initiates change",
        "title": "User initiates change",
        "src": "/static/7d5036d55a193da011d303f158aa4b0f/fb070/chatbot-12.png",
        "srcSet": ["/static/7d5036d55a193da011d303f158aa4b0f/d6747/chatbot-12.png 288w", "/static/7d5036d55a193da011d303f158aa4b0f/09548/chatbot-12.png 576w", "/static/7d5036d55a193da011d303f158aa4b0f/fb070/chatbot-12.png 1152w", "/static/7d5036d55a193da011d303f158aa4b0f/fb104/chatbot-12.png 1728w", "/static/7d5036d55a193da011d303f158aa4b0f/8fefe/chatbot-12.png 2240w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <h3 {...{
      "id": "notify-the-user"
    }}>{`Notify the user`}</h3>
    <p>{`Use a toast notification bar to indicate when the user is in a new conversation context, or that a new user has joined the the chat. Call out any significant changes with in-conversation status messages.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "48.839285714285715%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAAAy0lEQVQoz62STQrCMBCFe2033sCthxD3eg43gogWUYKFtvltm6bJM02riBTB1oEww8zjYya8CIPh4JwLlS4VnDV9v/EjP/vQvEc0iGuFvXi5STFfSyy2DrOVxv7WhL61vwL7TLISZyIRE4HjlUMW9Ws2ClgVEqXiPgufGRozESilBOMcnAswxlDXE4FKKQghwvsLsAVRSv2GHNQD9VjgU0zzHMmdIM2y8IewdWebKSe3pzpTYReXOJDOk3bshsYYVFoHU58Si0vqvgIfz8QTGQLQV6QAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Notify the user",
        "title": "Notify the user",
        "src": "/static/7c4f2a84e1d9dd043b87efca322263a7/fb070/chatbot-13.png",
        "srcSet": ["/static/7c4f2a84e1d9dd043b87efca322263a7/d6747/chatbot-13.png 288w", "/static/7c4f2a84e1d9dd043b87efca322263a7/09548/chatbot-13.png 576w", "/static/7c4f2a84e1d9dd043b87efca322263a7/fb070/chatbot-13.png 1152w", "/static/7c4f2a84e1d9dd043b87efca322263a7/fb104/chatbot-13.png 1728w", "/static/7c4f2a84e1d9dd043b87efca322263a7/8fefe/chatbot-13.png 2240w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <h3 {...{
      "id": "multiple-users"
    }}>{`Multiple users`}</h3>
    <p>{`Combining two or more human agents into the same thread is a common practice. Where necessary, call out significant changes in who the user is addressing (particularly if they have different purposes).`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "48.839285714285715%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAABWElEQVQoz5WSS0sDMRSF+4u7Km7dFirqjxBBRHDlxroTCq3FKS4cu5iF0s4D5pXJZJ7J8SbTimBpa+ASSHK+nJybHn4NpZSZ27aFEPnPmpQSTVNTVZuDsqutZqPTo7cLWFcVfG+NnKCcC8g6x+OC4+QqwuihwuldifuXDi5Jow4BtUPOORhjSNMUIucIwgzOKoEbFgiYQpK3WoHO4EFgY0CMZQaqq64KzKcT3N5cm1p+vHcOKY6DwIYchmEIliaUpUBZliRUGI+fMBqdYTgcYjqb/QPYNFivV7Be57AsC47jIKcIoigyF1WUsY5le34vcLtp2zYGgwH6/T7OLy5Npr7nGWgcx+C5+KPZ61A7cV0XQRDQu0rTGJeAnu+joO6rRkAdDaxrxOQkocYUIsOzXcILucmUZyl1WmCyLI93qGftsiKw/hqLTwkmJFr63Eq2SIXC25fcCfwG7acA4YWJPAoAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Multiple users",
        "title": "Multiple users",
        "src": "/static/93489695aae43e7f2c98739080335372/fb070/chatbot-14.png",
        "srcSet": ["/static/93489695aae43e7f2c98739080335372/d6747/chatbot-14.png 288w", "/static/93489695aae43e7f2c98739080335372/09548/chatbot-14.png 576w", "/static/93489695aae43e7f2c98739080335372/fb070/chatbot-14.png 1152w", "/static/93489695aae43e7f2c98739080335372/fb104/chatbot-14.png 1728w", "/static/93489695aae43e7f2c98739080335372/8fefe/chatbot-14.png 2240w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <h3 {...{
      "id": "incoming-messages"
    }}>{`Incoming messages`}</h3>
    <p>{`For new messages appearing in another thread, be sure to use dots above the Threads icon to alert the user of new messages. Then, within the menu, indicate the amount of new messages on the specific thread. Visually distinguish threads with new messages.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "48.839285714285715%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAABPUlEQVQoz5VSXWvCMBT15wsO3J/Q1v/QvQ1E+jDGHjr24phgU0v6ka/WNslZElF8kE0vhHBvcs/9OGeCK7PWhtsYg77vgm+MxagN9DjA6OHy7s8555znbXILcBgG5CRH2zbgnENJjn3J8ZbtUNIKjHFIKe8HHMcRVUXRKRHAvdUNQ3GgkIJD+461vvz/F9AYje/tFqtVjDiOkCQJhuMRm80acRRhuYyQZdll/D8Bz49bBzifP2M2m2GxWIRYkrw4/wnT6RRpmt4HeD1yVfl9sRDzu6ydTynF0XX70Mh+bwUhIbmuazAuHEEtiqIIRXxMSPUAKa56WZbI830Agu4c08L5BIQU6DsJOyrYR1humsadFr1j+vWzB6ECzMlI8BY5VVh/9fd36G8PepKMxfuPAVMncVungFZZfOxuC/sXNGADHCOz0e8AAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Incoming messages",
        "title": "Incoming messages",
        "src": "/static/205db7c5224c1b9be270bc38b1a62127/fb070/chatbot-15.png",
        "srcSet": ["/static/205db7c5224c1b9be270bc38b1a62127/d6747/chatbot-15.png 288w", "/static/205db7c5224c1b9be270bc38b1a62127/09548/chatbot-15.png 576w", "/static/205db7c5224c1b9be270bc38b1a62127/fb070/chatbot-15.png 1152w", "/static/205db7c5224c1b9be270bc38b1a62127/fb104/chatbot-15.png 1728w", "/static/205db7c5224c1b9be270bc38b1a62127/8fefe/chatbot-15.png 2240w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <h2 {...{
      "id": "expanding-cards-experimental"
    }}>{`Expanding cards (Experimental)`}</h2>
    <p>{`Where needed, use expanding cards to progressively disclose content. Use a full page view to show a very large amount of content to the user.`}</p>
    <h3 {...{
      "id": "default-state"
    }}>{`Default state`}</h3>
    <p>{`Call out critical information in the default state. Provide a trigger to expand the card.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "48.839285714285715%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAAAo0lEQVQoz62SSwvCMBCE+/9/nzfBQy42rUXS3Tya15hElB5EoWZgWZhdPmZhB3xQzrlV1Z0i3OarixjT29/v7DX8AoqRIacZxmgQEbz3x4Cv7gyDC2hdCUqp/4HMXGBrS1d7X2CPhFrrBq1nqx4JqUCkHFtK2wXIGvNtgbWuOKlUwHN89GTjQHorLI+T2HC+xjZLR/8whADnarqIy5QglvwV+AAAZBaAOOHRXgAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Default state",
        "title": "Default state",
        "src": "/static/8a5416789797b5e86202f444571900ec/fb070/chatbot-16.png",
        "srcSet": ["/static/8a5416789797b5e86202f444571900ec/d6747/chatbot-16.png 288w", "/static/8a5416789797b5e86202f444571900ec/09548/chatbot-16.png 576w", "/static/8a5416789797b5e86202f444571900ec/fb070/chatbot-16.png 1152w", "/static/8a5416789797b5e86202f444571900ec/fb104/chatbot-16.png 1728w", "/static/8a5416789797b5e86202f444571900ec/8fefe/chatbot-16.png 2240w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <h3 {...{
      "id": "expanded-state"
    }}>{`Expanded state`}</h3>
    <p>{`Provide more detailed information in the expanded state. Only if absolutely necessary, provide a way to access the full view of the content.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "48.839285714285715%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAAAsklEQVQoz6WSzQrCMBCE+/7P503w0IumxWqbv22ymzFJUXoQhWZgWNiEj9lsOnxRSqm66KEZtIbSBbN8+vs7e3X/gP3N4KZGOGegtUYI4RjwXclbWLvB5mVuBxpjMU0TtDGgZUFsBZZkSil475GYwTG2Aa1z1SICLs7QtpFzwnFQtZYtx9gEFFgfMLsMqhzJZmzHh0cmPDVl1opTv+J83d5Qjv7DmJdARDXZZRD09/QT+ALr0xc+/5hhxAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Expanded state",
        "title": "Expanded state",
        "src": "/static/12f7b07d0076764f4244a259626eac51/fb070/chatbot-17.png",
        "srcSet": ["/static/12f7b07d0076764f4244a259626eac51/d6747/chatbot-17.png 288w", "/static/12f7b07d0076764f4244a259626eac51/09548/chatbot-17.png 576w", "/static/12f7b07d0076764f4244a259626eac51/fb070/chatbot-17.png 1152w", "/static/12f7b07d0076764f4244a259626eac51/fb104/chatbot-17.png 1728w", "/static/12f7b07d0076764f4244a259626eac51/8fefe/chatbot-17.png 2240w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <h3 {...{
      "id": "full-view"
    }}>{`Full view`}</h3>
    <p>{`The full view is a generic container that can be used to display long-form content that would otherwise crowd a conversation thread.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "48.839285714285715%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAAAmklEQVQoz62SbQuFIAyF+/9/MqI01HyBFEStc9ngXvoQBNcOjMGUZ5vHATc6z5ODdBwHaq0opaC19qtf71w1PAH3fYeUEt57BlKDLqC1FvM8QwjB0O/Z30ClFKZp4kzw7gm3bWMYvSPVuoHGGKzryjmE0G+K1hrjOGJZFjaHjOkC0lTOOcQYkVJ6Z2VymdZ+xRT60DlnzhRPwA9P0RTOYo8wJAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Full view",
        "title": "Full view",
        "src": "/static/ab95d9039ed5c64f85783ebf6a26d2e6/fb070/chatbot-18.png",
        "srcSet": ["/static/ab95d9039ed5c64f85783ebf6a26d2e6/d6747/chatbot-18.png 288w", "/static/ab95d9039ed5c64f85783ebf6a26d2e6/09548/chatbot-18.png 576w", "/static/ab95d9039ed5c64f85783ebf6a26d2e6/fb070/chatbot-18.png 1152w", "/static/ab95d9039ed5c64f85783ebf6a26d2e6/fb104/chatbot-18.png 1728w", "/static/ab95d9039ed5c64f85783ebf6a26d2e6/8fefe/chatbot-18.png 2240w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <h2 {...{
      "id": "error-states-experimental"
    }}>{`Error states (Experimental)`}</h2>
    <p>{`Be sure to indicate to a user when their message has not been sent due to a connectivity or server problem. When in a connected state, temporarily show the success notification, and then remove it along with any message error indicators.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "48.839285714285715%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAABWklEQVQoz42SX0/CMBTF+bBqwgsJX0rDk+++EOXJKEPBBTMDBIiMjTFY16770/bYbjBNNEKTs3t6mv56b7IGDkspI1V6wgGeKUhlVOU813lSeZMJWd3R30OtVuMbqGrgcrXCbPoOEs4hsgBFusU+2mH8biNwHb3fIGMepMjru38Cj53mPASNfMRRAEo2YHSvwXvQ3RzhZqHPXHDqQRQngMcDxjgiEoPEtKyUMvA0054h1p4Qk1MIIc4Dcp4gjg2I1jVN04OvRAg5H0gigvV6Dc/z4Pu+7pghYYnOvDIzIiQ6HxiGIYbDIUajESaTiR6dlVDbtsvccRwE21AD5Wng8dVOp4Nms4lWq4UP+7HMHno9tNttXFxeoXt3W2ZSqv+BRnmeYzqbwbL6eHp+wfV9gKyQcN0V+tYAb68WbrpLfO4qkDw1suny56uDhf6VCqG7kXU2doEgVr9G/gJalABSXkgkKAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Chatbot error notification",
        "title": "Chatbot error notification",
        "src": "/static/34af964999a53cfc8a2884c35865ee05/fb070/chatbot-6.png",
        "srcSet": ["/static/34af964999a53cfc8a2884c35865ee05/d6747/chatbot-6.png 288w", "/static/34af964999a53cfc8a2884c35865ee05/09548/chatbot-6.png 576w", "/static/34af964999a53cfc8a2884c35865ee05/fb070/chatbot-6.png 1152w", "/static/34af964999a53cfc8a2884c35865ee05/fb104/chatbot-6.png 1728w", "/static/34af964999a53cfc8a2884c35865ee05/8fefe/chatbot-6.png 2240w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "loading": "lazy"
      }}></img>{`
    `}</span>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      